/*
For doing tests to create the propper data structure. 

Main structures are:

Category [list] (ex: Food, Bathroom, workout, Sleep, mood)
- id
- name
- background color
- [list] array of entries; (ex: milk, booty burn, diarrhea) - could be a new unique item, or referencing an existing item 

Entry [list] (ex: diarrhea, milk, booty burn, workout, Sleep)
- id
- date started
- date ended (optional- if a thing took time, like a workout])
- id_item_type [foreign key to ItemType]

ItemType [list]
- id
- name (milk, booty burn, workout)
= attributes (an name + value if possible; ex: calories: 100, bathroom_type: diarrhea, )
*/
export default class DataBaseTests
{
    constructor()
    {
    }

    //adding user id

    static users = [
        {id:0, name:"Chris", date_updated:DataBaseTests.GetDate(-22)}, 
        {id:1, name:"Megan", date_updated:DataBaseTests.GetDate(-5)},
    ];

    //categories to add for all users
    static cats_default = [
        {id:0, id_user:0, name:"Food", color_bg:"blue", color_txt:"white", icon:"restaurant", date_updated:DataBaseTests.GetDate(-22)}, 
        {id:1, id_user:0, name:"Bathroom", color_bg:"brown", color_txt:"white", icon:"wc", date_updated:DataBaseTests.GetDate(-25)},
        {id:2, id_user:0, name:"Exercise", color_bg:"yellow", color_txt:"black", icon:"sports_martial_arts", date_updated:DataBaseTests.GetDate(-12)},
        {id:3, id_user:0, name:"Mood", color_bg:"blue", color_txt:"white", icon:"mood", date_updated:DataBaseTests.GetDate(-2)},
        {id:4, id_user:0, name:"Medicine", color_bg:"purple", color_txt:"white", icon:"pill", date_updated:DataBaseTests.GetDate(-24)},
        {id:5, id_user:0, name:"Sleep", color_bg:"red", color_txt:"white", icon:"king_bed", date_updated:DataBaseTests.GetDate(-38)},
    ];

        static cats = [
            {id:0, id_user:0, name:"Food", color_bg:"blue", color_txt:"white", icon:"restaurant", date_updated:DataBaseTests.GetDate(-22)}, 
            {id:1, id_user:0, name:"Bathroom", color_bg:"brown", color_txt:"white", icon:"wc", date_updated:DataBaseTests.GetDate(-25)},
            {id:2, id_user:0, name:"Exercise", color_bg:"yellow", color_txt:"black", icon:"sports_martial_arts", date_updated:DataBaseTests.GetDate(-12)},
            {id:3, id_user:0, name:"Mood", color_bg:"blue", color_txt:"white", icon:"mood", date_updated:DataBaseTests.GetDate(-2)},
            {id:4, id_user:0, name:"Medicine", color_bg:"purple", color_txt:"white", icon:"pill", date_updated:DataBaseTests.GetDate(-24)},
            {id:5, id_user:0, name:"Sleep", color_bg:"red", color_txt:"white", icon:"king_bed", date_updated:DataBaseTests.GetDate(-38)},

            // {id:6, id_user:1, name:"M_Bathroom", color_bg:"red", color_txt:"white", icon:"wc", date_updated:DataBaseTests.GetDate(-38)},
            // {id:6, name:"Changes", color_bg:"red", color_txt:"white", icon:"", date_updated:DataBaseTests.GetDate(-1)},
        ];
        
        static item_types = [
            //so start with food item types
            {id:0, id_user:0, id_cat:0, name:"Milk", date_updated:DataBaseTests.GetDate(-22)/* , attributes:{calories:100, fat:10, tasty:"yes"} */},
            {id:1, id_user:0, id_cat:0, name:"Pizza", date_updated:DataBaseTests.GetDate(-4)},
            {id:2, id_user:0, id_cat:0, name:"Cauliflower rice", date_updated:DataBaseTests.GetDate(-8)},

                    //bathrooms
            {id:3, id_user:0, id_cat:1, name:"Diarrhea", date_updated:DataBaseTests.GetDate(-15)/* , attributes:{urgent:"yes", color:"yellow"} */ },
            {id:4, id_user:0, id_cat:1, name:"Diarrhea EVERYWHERE", date_updated:DataBaseTests.GetDate(-32)},
            {id:5, id_user:0, id_cat:1, name:"Explosive diarrhea", date_updated:DataBaseTests.GetDate(0)},
            {id:6, id_user:0, id_cat:1, name:"Wattery Diarrhea", date_updated:DataBaseTests.GetDate(-200)},
            {id:7, id_user:0, id_cat:1, name:"yellow water", date_updated:DataBaseTests.GetDate(-5)},

                    //exercise:
            {id:8, id_user:0, id_cat:2, name:"Booty burn", date_updated:DataBaseTests.GetDate(-96)/* , attributes:{time:"10mins", intensity:"hard"} */ },
            {id:9, id_user:0, id_cat:2, name:"Forest Walk", date_updated:DataBaseTests.GetDate(-1)/* , attributes:{time:"30mins", location:"forest behind us"} */ },

                    //mood
            {id:10, id_user:0, id_cat:3, name:"Hangry", date_updated:DataBaseTests.GetDate(-1)/* , attributes:{time:"30mins", location:"forest behind us"} */ },

            //m item type
            {id:11, id_user:1, id_cat:6, name:"Constipated", date_updated:DataBaseTests.GetDate(-32)},
            {id:12, id_user:1, id_cat:6, name:"Hard Bunny poos", date_updated:DataBaseTests.GetDate(-200)},

        ];

        static entries = [
        // {id:0, id_item_type:6, id_cat:2, date_updated:DataBaseTests.GetDate(-120), date_finished:DataBaseTests.GetDate(-100)},

        // {id:1, id_item_type:0, id_cat:0, date_updated:DataBaseTests.GetDate(-36), date_finished:undefined},

                                //bathroom
        {id:0, id_user:0, id_item_type:3, id_cat:1, date_updated:DataBaseTests.GetDate(-4), date_finished:DataBaseTests.GetDate(-3), has_duration:true},
        // {id:3, id_item_type:4, id_cat:1, date_updated:DataBaseTests.GetDate(-6), date_finished:DataBaseTests.GetDate(-5)},

                                //exercise
        // {id:4, id_item_type:6, id_cat:2, date_updated:DataBaseTests.GetDate(-4, -1), date_finished:DataBaseTests.GetDate(-2, -1)},
        // {id:5, id_item_type:6, id_cat:2, date_updated:DataBaseTests.GetDate(-100), date_finished:DataBaseTests.GetDate(-150)},

        // {id:6, id_item_type:7, id_cat:3, date_updated:DataBaseTests.GetDate(-100), date_finished:DataBaseTests.GetDate(-150)},

        //megan bathroom
        {id:1, id_user:1, id_item_type:11, id_cat:6, date_updated:DataBaseTests.GetDate(-4), date_finished:DataBaseTests.GetDate(-3), has_duration:true},
        ];

        


        //so things like "milk: calories: 100" or "bathroom: consistancy: loose"
        //can have multiple attributes for an entry
        static entry_attributes =[
            // food : 0, cat id 1: bathroom, 2 exercise
            {id:0, id_user:0, id_cat:0, id_item_type:0, id_entry:100, name:"calories", value:"100", rating:-1, date_updated:DataBaseTests.GetDate(-4)},
            {id:1, id_user:0, id_cat:0, id_item_type:0, id_entry:100,name:"fat g", value:"5", rating:-1, date_updated:DataBaseTests.GetDate(-8)},
            
            
            {id:2, id_user:0, id_cat:1, id_item_type:3, id_entry:0, name:"Consistancy", value:"loose", rating:1, date_updated:DataBaseTests.GetDate(-1)},
            {id:3, id_user:0, id_cat:1, id_item_type:3, id_entry:0, name:"Smell", value:"WHoa", rating:-1, date_updated:DataBaseTests.GetDate(-1)},
            {id:4, id_user:0, id_cat:1, id_item_type:3, id_entry:0, name:"Smell", value:"Hory sheet!", rating:0, date_updated:DataBaseTests.GetDate(-1)},
            {id:5, id_user:0, id_cat:1, id_item_type:3, id_entry:0, name:"Color", value:"Yellow", rating:0, date_updated:DataBaseTests.GetDate(-1)},

                            //6: forest walk    
            {id:6, id_user:0, id_cat:2, id_item_type:6, id_entry:4, name:"Calories burned", value:"500", rating:10, date_updated:DataBaseTests.GetDate(-1)},

            //M bathroom
            {id:7, id_user:1, id_cat:6, id_item_type:11, id_entry:1, name:"Consistancy", value:"bunny poo", rating:1, date_updated:DataBaseTests.GetDate(-1)},

        ];
        // let test_data = {
        //     //first an array of categories
        //     Cats:
        // };

        static GetDate(hours:number, years?:number):Date
        {
            let date = new Date();
            
                date.setHours(date.getHours()+hours);
            if(years)
                date.setFullYear(date.getFullYear()+years);

            return date;
        }
    
}